import { EthnicgroupService } from "../../services/models/ethnicGroup";
const moduleEthnicGroup = {
	namespaced: true,
	state: {
		ethnicGroups: [],
		loading: false,
	},
	getters: {
		getEthnicGroups(state) {
			return state.ethnicGroups;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadEthnicGroups(state, ethnicGroups) {
			state.ethnicGroups = ethnicGroups;
		}
	},
	actions: {
		async loadEthnicGroups({ commit, state }) {
			state.loading = true;
			let ethnicGroups = await EthnicgroupService.getAll();
			commit("loadEthnicGroups", ethnicGroups);
			state.loading = false;
		}
	}
}

export default moduleEthnicGroup;